// src/app/shared/session-modal.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface SessionModalData {
  code: 'SESSION_REPLACED' | 'SESSION_INACTIVE';
  message: string;
}

@Injectable({ providedIn: 'root' })
export class SessionModalService {
  private dataSubject = new BehaviorSubject<SessionModalData | null>(null);
  data$ = this.dataSubject.asObservable();

  show(data: SessionModalData) {
    this.dataSubject.next(data);
  }

  hide() {
    this.dataSubject.next(null);
  }
}